import React from "react";
import { _colorText, _sizeText } from "../../core/core";
import { Text } from "../texts/text";
import "./CalendarItem.css";

interface CalendarItemProps {
  selected?: boolean;
  today?: boolean;
  addons?: boolean;
  weekend?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const CalendarItem: React.FC<CalendarItemProps> = ({
  selected = false,
  today = false,
  addons = false,
  weekend = false,
  disabled = false,
  children,
}) => {
  const variantsClassName = [
    selected ? "c-selected-true" : "c-selected-false",
    weekend ? "c-weekend-true" : "c-weekend-false",
    disabled ? "c-disabled-true" : "c-disabled-false",
  ].join(" ");

  return (
    <div className={`calendar-item ${variantsClassName}`}>
      <Text size={_sizeText.m} color={_colorText.black}>
        {children}
      </Text>
      {today ? (
        <div className="calendar-today"></div>
      ) : (
        addons && <div className="calendar-today c-addons"></div>
      )}
    </div>
  );
};
